'use strict';

var evence = require('events');
var util = require('util');

function XoEmitter() {
    evence.EventEmitter.call(this);
}

util.inherits(XoEmitter, evence.EventEmitter);

module.exports = XoEmitter;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/xo-emitter.js
 ** module id = 22
 ** module chunks = 0
 **/